module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-onlinesupport-618d7f1d44c042f5275027c205275433.webp";